var map = {
	"./BaseAutocompletePlace.vue": "PcL+",
	"./BaseAutocompleteProduct.vue": "Vrsm",
	"./BaseDeleteButton.vue": "0iop",
	"./BaseDeleteButtonVuex.vue": "ldsv",
	"./BaseSubmitButton.vue": "5Yqy",
	"./BaseTableDetails.vue": "TRvI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/w0S";


//////////////////
// WEBPACK FOOTER
// ./src/components nonrecursive Base[A-Z]\w+\.(vue|js)$
// module id = /w0S
// module chunks = 67